module.exports = __webpack_public_path__ + "static/media/bloomnetLogoSmall.1535bb18.png";